<div class="new-content" *ngIf="!pane || !rawContentItems; else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="content">
    <ng-template [ngIf]="!!blockTitle?.title">
      <app-library-title [title]="blockTitle"></app-library-title>
    </ng-template>

    <div class="filter-block" [class.mobile]="deviceService.isMobile()" [class.move-top]="isAuthenticated">
      <div class="filter-scroll">
        <ul class="filter-list">
          <li
            *ngFor="let tab of tabs; let i = index; trackBy: trackByFn"
            class="filter-item"
            [class.selected]="tab.code === activeTab?.code"
            (click)="activateTab(tab)">
            <span class="filter-label">{{ tab.title | customLocale }}</span>
            <div appRedPoint class="red-point" [event]="redPointEvent(tab)"></div>
          </li>
        </ul>
      </div>
      <ng-template [ngIf]="!isGuest">
        <on-ui-button
          *ngIf="!deviceService.isMobile()"
          label="my-library.actions.create-service"
          data-test="library-create-class"
          class="poutline"
          (onclick)="onCreate()">
        </on-ui-button>

        <div *ngIf="deviceService.isMobile()" class="create-item" (click)="onCreate()">
          <div class="action-icon-wrap">
            <app-icon [width]="10" [height]="10" icon="plus"></app-icon>
          </div>
        </div>
      </ng-template>
    </div>

    <div *ngFor="let service of rawContentItems; trackBy: trackByFn" class="block">
      <app-library-service-mini
        [service]="service"
        (selected)="onSelect(service)"
        (openUserServiceInModal)="toggleEntityModal($event)">
      </app-library-service-mini>
    </div>

    <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
    <span inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>

    <ng-container *ngIf="!rawContentItems.length && !pane.loading" [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-no-content-stub *ngIf="isAsIfTeacher" [icon]="'stat-class-2'" [text]="'my-library.stub.stub4'">
  </app-no-content-stub>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && entityInModal" [canClose]="false" (closed)="toggleEntityModal($event)">
  <app-modal-body>
    <app-user-service-card-full [userService]="openedEntity" [modal]="true"> </app-user-service-card-full>
  </app-modal-body>
</app-modal>

<app-mobile-modal
  *ngIf="!deviceService.isDesktop() && entityInModal"
  [titleVisible]="true"
  (closed)="toggleEntityModal($event)">
  <app-mobile-modal-body>
    <app-user-service-card-full [userService]="openedEntity" [modal]="true"> </app-user-service-card-full>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-modal *ngIf="!deviceService.isMobile() && editService" (closed)="toggleEntityModal($event)">
  <app-modal-body>
    <app-user-service-form [userService]="editService" (changed)="onCloseForm($event)"></app-user-service-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal
  *ngIf="deviceService.isMobile() && editEntity"
  [titleVisible]="false"
  [withCloseButton]="true"
  [customTitle]="'teacher-profile.edit-service' | customLocale"
  (closed)="toggleEntityModal($event)">
  <app-mobile-modal-body>
    <app-user-service-form [userService]="editEntity" (changed)="onCloseForm($event)"></app-user-service-form>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-modal *ngIf="!deviceService.isMobile() && newEntity" [canClose]="false" (closed)="toggleEntityModal($event)">
  <app-modal-body>
    <app-user-service-form (changed)="onCloseForm($event)"></app-user-service-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal
  *ngIf="deviceService.isMobile() && newEntity"
  [titleVisible]="false"
  [withCloseButton]="true"
  [customTitle]="'teacher-profile.new-service' | customLocale"
  (closed)="toggleEntityModal($event)">
  <app-mobile-modal-body>
    <app-user-service-form (changed)="onCloseForm($event)"></app-user-service-form>
  </app-mobile-modal-body>
</app-mobile-modal>
